import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import { MicroserviceRequest } from '../../types/microservices'

const { MICROSERVICES_API_URL } = CONSTANT

const createNewMicroservice = async (
	newMicroservice: MicroserviceRequest
): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(
		`${MICROSERVICES_API_URL}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				action: 'CREATE'
			},
			body: JSON.stringify(newMicroservice)
		}
	)

	return response.json()
}

export default createNewMicroservice
